import React, {useEffect, useMemo, useRef} from 'react';
import {MapContainer, Popup, Marker, TileLayer, useMap} from 'react-leaflet';
import marker from '../assets/location.png';
import L,{ Icon} from 'leaflet';
import "leaflet/dist/leaflet.css"

function CenterMapWithPosition({selectedPlace}) {
  const map = useMap();

  useEffect(() => {
    if (selectedPlace) {
      map.setView(
        L.latLng(selectedPlace?.lat, selectedPlace?.lon),
        map.getZoom(),
        {
          animate: true
        }
      )
    }
  }, [selectedPlace, map])

  return null;
}

function Map({selectedPlace, scrollToZoom, draggable}) {
  const markerRef = useRef(null);

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current
        if (marker !== null) {
          const latLng = marker.getLatLng();
          
          if (selectedPlace) {
            selectedPlace.lat = latLng.lat;
            selectedPlace.lon = latLng.lng;
          } 
        }
      },
    }),
    [selectedPlace],
  )
    
  const customIcon = new Icon({
    iconUrl: marker,
    iconSize: [32,32]
  })

  const defaultPosition = [10.036204986122737, -84.15743663020278]
  const position = [selectedPlace?.lat, selectedPlace?.lon];

  return (
    <div className='w-full h-full'>
        <MapContainer center={selectedPlace && position? position:defaultPosition} zoom={17} scrollWheelZoom={scrollToZoom}>
            <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://api.maptiler.com/maps/topo-v2/{z}/{x}/{y}.png?key=TxWjAsvHEB9Z5IFZdMzk"
            />

            { selectedPlace ?
              <Marker draggable={draggable} ref={markerRef} eventHandlers={eventHandlers} position={selectedPlace && position? position:defaultPosition} icon={customIcon}>
                <Popup>
                    {selectedPlace && position? <div className='text-center'>Seleccionado {selectedPlace.address.county} <br /> {selectedPlace.address.neighbourhood}</div> : "Laboratorio Santa Bárbara"}
                </Popup>
              </Marker>
              :
              <></>
            }
            
            <CenterMapWithPosition selectedPlace={selectedPlace} />
        </MapContainer>
    </div>
  )
}

export default Map;
